// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__I9tB5","colMin":"styles_colMin__2W_ej","colCheckbox":"styles_colCheckbox__2vjFN"};